export default function ProcessTimeline() {
  const steps = [
    {
      number: '1',
      title: 'Consultation',
      description: 'We meet at your property to discuss your vision, assess the space, and understand your needs and budget.',
      icon: 'ri-chat-4-line'
    },
    {
      number: '2',
      title: 'Design',
      description: 'Our team creates detailed plans and 3D renderings so you can visualize your new outdoor space before we begin.',
      icon: 'ri-pencil-ruler-2-line'
    },
    {
      number: '3',
      title: 'Proposal',
      description: 'You receive a comprehensive proposal with transparent pricing, timeline, and material specifications.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '4',
      title: 'Installation',
      description: 'Our skilled craftsmen bring your design to life with meticulous attention to detail and quality workmanship.',
      icon: 'ri-tools-line'
    },
    {
      number: '5',
      title: 'Completion',
      description: 'Final walkthrough ensures everything exceeds your expectations. Your satisfaction is our guarantee.',
      icon: 'ri-checkbox-circle-line'
    }
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(#E67E22 1px, transparent 1px), linear-gradient(90deg, #E67E22 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Our Proven Process</h2>
          <p className="text-xl text-gray-600">From concept to completion, we guide you through every step</p>
        </div>

        <div className="relative">
          {/* Desktop Timeline */}
          <div className="hidden lg:flex items-start justify-between gap-6 mb-12">
            {steps.map((step, index) => (
              <div key={index} className="flex-1 relative">
                {index < steps.length - 1 && (
                  <div className="absolute top-10 left-[60%] w-full h-0.5 border-t-2 border-dashed border-[#E67E22]"></div>
                )}
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 relative z-10">
                  <div className="w-20 h-20 rounded-full bg-[#E67E22] flex items-center justify-center text-white text-3xl font-bold mb-6 mx-auto shadow-lg">
                    {step.number}
                  </div>
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-3xl text-[#E67E22]`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed text-center">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile Timeline */}
          <div className="lg:hidden space-y-6">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {index < steps.length - 1 && (
                  <div className="absolute left-10 top-24 w-0.5 h-full border-l-2 border-dashed border-[#E67E22]"></div>
                )}
                <div className="bg-white rounded-2xl p-8 shadow-lg relative z-10">
                  <div className="flex items-start gap-6">
                    <div className="flex-shrink-0 w-20 h-20 rounded-full bg-[#E67E22] flex items-center justify-center text-white text-3xl font-bold shadow-lg">
                      {step.number}
                    </div>
                    <div className="flex-1">
                      <div className="w-10 h-10 flex items-center justify-center mb-3">
                        <i className={`${step.icon} text-2xl text-[#E67E22]`}></i>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                      <p className="text-gray-600 leading-relaxed">{step.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}